import { router } from '../router'
import { isApp as isAppIndex } from '..'
import { AppAuth } from './auth'
import { AppEnum } from './data/enum'
import {
  waitForCondition as wafc,
  downloadUrl as _downloadUrl,
  downloadFileObject as _downloadFile,
  getColorVariables,
} from './function'
import { getUnixtime as _getUnxitime } from '@/lib'
import { Toast } from './toast'
import { Confirm } from './confirm'
import { ref, watch } from 'vue'
import _ from 'lodash'
import { AppUpload } from './upload'
import { GlobalStore } from './store'
import { CloudFile } from '@/lib/CloudFile'
import { Network } from '@capacitor/network'
import { Capacitor } from '@capacitor/core'
import { registerCameraEventListener, cleanupCameraSystem } from './camera'
import { useAllTaskStore } from './store/task'
import { useDocStore } from './data/Editor/docs'

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace App {
  export import Auth = AppAuth
  export const Enum = AppEnum
  export import Global = GlobalStore

  export const Router = router

  export import Upload = AppUpload

  export const colors = getColorVariables()

  export const isOnline = ref<boolean>(false)
  watch(isOnline, value => {
    if (value) {
      // AppUpload.uploadAll()
    }
  })

  export async function onMounted(): Promise<void> {
    const allTaskStore = useAllTaskStore()
    const docStore = useDocStore()
    AppAuth.setErrorListener('onLogout', async _e => {
      // store 정리
      allTaskStore.allClear() // 과업
      docStore.allClear() // 문서
      router.push('/login')
    })
    Network.addListener('networkStatusChange', status => {
      isOnline.value = status.connected
    })

    // iOS에서 Photos 권한 요청
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      try {
        const { requestPhotosPermission } = await import('@/app/native')
        const result = await requestPhotosPermission()
        console.info('[App] Photos permission result:', result)
      } catch (error) {
        console.error('[App] Failed to request Photos permission:', error)
      }
    }

    // 업로드 절차 추가하기
    await AppUpload.uploadAll()

    // 카메라 이벤트 리스너 등록
    await registerCameraEventListener()

    await AppAuth.onMounted()
  }
  export async function onUnmounted(): Promise<void> {
    Network.removeAllListeners()

    // 카메라 이벤트 리스너 제거
    await cleanupCameraSystem()
  }

  export async function waitForCondition(
    condition: () => boolean,
    delay?: number,
    timeout?: number,
  ): Promise<void> {
    return await wafc(condition, delay, timeout)
  }

  export const isApp = (): boolean => isAppIndex()

  export const getUnixtime = (): number => {
    return _getUnxitime()
  }

  export const toastInstance: Toast = new Toast()
  export const confirmInstance: Confirm = new Confirm()
  export const loadingIndicator = ref<boolean>(false)

  export const ResourceUrlToBase64 = async (resourceUrl: string): Promise<string> => {
    const base64 = await CloudFile.getBase64FromResourceUrl(resourceUrl)
    return base64
  }

  // RouteTransitionX 추적용 path ref
  export const previousPath = ref<string | null>(null)
  export const downloadUrl = _downloadUrl
  export const downloadFile = _downloadFile
}
